export default __webpack_public_path__ + "media/src/assets/images/back_arrow-6e4f91cd82b262240c94526555d890b4.svg";